import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import FieldModal from 'modules/custom_resources/components/CustomFields/FieldModal'
import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'

interface Props {
  readonly?: boolean
  field: CustomField
  onClose: () => void
  onSubmit: (data: Record<string, unknown>) => Promise<void>
}

export default function QuestionConfigModal({ readonly = false, field, onClose, onSubmit }: Props) {
  return (
    <FieldModal
      readonly={readonly}
      modalIllustration="server-edit"
      modalTitle={i18n.t('surveys.form.question_configs.edit.title')}
      modalDescription={i18n.t('surveys.form.question_configs.edit.description')}
      modalLabel={i18n.t('surveys.form.question_configs.edit.label')}
      modalPlaceholder={i18n.t('surveys.form.question_configs.edit.label_placeholder')}
      modalButton={i18n.t('surveys.form.question_configs.edit.submit')}
      allowPermissions={false}
      showAllowedFieldTypes
      allowedFieldTypes={[
        FieldTypes.text,
        FieldTypes.singleChoice,
        FieldTypes.rating,
        FieldTypes.cents,
      ]}
      field={field}
      showRequired
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}
